import classNames from 'classnames'
import CommonIcon from 'CommonIcon'
import { selectChannelsType } from 'data/selectors'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { countryIdToString, countryShortNameToString, formatValidNumber, getNumberWithCurrency } from 'utils'

import Box from '@mui/material/Box'

function TableOrdersRow({ data, index, style }) {
  const { t: translate } = useTranslation()
  const { displayChannel, showModal, maxOrdersValue, stores, totalOrders, totalOrdersValue, type } = data
  const store = stores[index]
  const channelsType = useSelector(selectChannelsType)
  const modalHandler = () => showModal(store)
  const barWidth = Math.round((100 * store.ordersValue) / maxOrdersValue)
  const countryShortName = store.storeName.split(' ').pop()
  const fallbackCountryName = countryIdToString(store.countryId)
  const percentOfTotalOrders = store.orders ? Math.round((100 * store.orders) / totalOrders) : 0
  const percentOfTotalOrdersValue = store.ordersValue ? Math.round((100 * store.ordersValue) / totalOrdersValue) : 0
  const showSmallLogo = ['group', 'saleTypes', 'countries'].includes(channelsType)
  const iconName = showSmallLogo ? store.storeChannel : countryShortNameToString(countryShortName, fallbackCountryName)
  const showStoreChannel = type === 'group' || displayChannel

  return (
    <Box
      style={style}
      onClick={modalHandler}
      className={classNames('row cursor-pointer', { 'is-temporary-closed': store.temporaryClosed })}
    >
      <div className="row-wrapper flex-row">
        <div className="cell-bar" style={{ width: `${barWidth}%` }} />

        <div className="cell-title flex-row">
          <CommonIcon name={iconName} />
          {store.position}
          {showStoreChannel && store.storeChannel} {store.storeName}
        </div>

        <div className="cell cell-orders-value">
          {getNumberWithCurrency({
            number: store.ordersValue,
            precision: 0,
            translate,
          })}
        </div>

        <div className="cell cell-orders">
          <span>{formatValidNumber(store.orders)}</span>
        </div>

        <div className="cell cell-order-value">
          <span>
            {getNumberWithCurrency({
              number: store.orderValue,
              precision: 2,
              translate,
            })}
          </span>
        </div>

        <div className="cell cell-orders-value-share">
          <span>{formatValidNumber(percentOfTotalOrdersValue, '%')}</span>
        </div>

        <div className="cell cell-orders-share">
          <span>{formatValidNumber(percentOfTotalOrders, '%')}</span>
        </div>
      </div>
    </Box>
  )
}

TableOrdersRow.propTypes = {
  data: PropTypes.shape({
    maxOrdersValue: PropTypes.number,
    percentOfTotalOrders: PropTypes.number,
    percentOfTotalOrdersValue: PropTypes.number,
    showModal: PropTypes.func,
    stores: PropTypes.arrayOf(PropTypes.object),
  }),
  index: PropTypes.number,
  style: PropTypes.object,
}

export default TableOrdersRow
